<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.user_nick" placeholder="请输入用户名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="userNick" label="用户名称"></el-table-column>
            <el-table-column prop="userPhone" label="手机号码"></el-table-column>
            <el-table-column prop="userImage" label="用户头像">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="scope.row.userImage" fit="cover"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.userDate) }}
                </template>
            </el-table-column>
            <el-table-column label="用户角色">
                <template slot-scope="scope">
                    {{ scope.row.userStatus == 1 ? "分销用户" : "普通用户" }}
                </template>
            </el-table-column>
            <el-table-column prop="userMemo" label="用户备注"></el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="用户角色">
                        <el-select v-model="handleInfo.userStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="普通用户" :value="0"></el-option>
                            <el-option label="分销用户" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户备注">
                        <el-input v-model="handleInfo.userMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "USER";
        this.uploads.push({
            column: "userImage",
            files: []
        });
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>